import React, { useEffect } from 'react'
import { connect } from 'react-redux'

const buildphotoMarkerTemplate = (url, color, index) => {
  // const colorMarker = color ? color[0] != '#' ? '#' + color : color : '#333'
  // const colorMarker = color?.startsWith("#") ? color : "#" + color?.replace(/^.{0,2}/, "") || "#9ecc3b";
  const colorMarker = color?.replace(/^#?([a-fA-F0-9]{6}).*$/, '#$1') || '#9ecc3b';

  const safeUrl = url?.includes(" ") ? url.replace(/\s/g, "%20") : url;
  const fallbackUrl = "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/June_odd-eyed-cat.jpg/300px-June_odd-eyed-cat.jpg";
  const imageUrl = safeUrl || fallbackUrl;

  const template = document.createElement("template");
  template.innerHTML = `
    <svg width="40" height="50" viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="circleClip">
          <circle cx="20" cy="20" r="15" />
        </clipPath>
      </defs>

      <!-- Outer circle (border) -->
      <circle cx="20" cy="20" r="17" fill="${colorMarker}" />

      <!-- Inner white circle -->
      <circle cx="20" cy="20" r="15" fill="#FFFFFF" />

      <!-- Index text inside the circle -->
      <text x="20" y="25" text-anchor="middle" font-size="14" fill="#333" font-weight="bold">
        ${index + 1}
      </text>

      <!-- Downward triangle (pointer) -->
      <polygon points="20,47 12,35 28,35" fill="${colorMarker}" />
    </svg>
  `;
  return template;
};



const RenderPhotos = (props) => {
  let { mapReferenceThreed, photos } = props
  useEffect(() => {
    if (!mapReferenceThreed || typeof mapReferenceThreed.append !== 'function') {
      console.warn("Invalid mapReferenceThreed:", mapReferenceThreed);
      return;
    }

    if (mapReferenceThreed) {
      mapFunction();
    }
  }, [mapReferenceThreed, photos]); // ✅ Run only when mapReference is updated from undefined → defined

  async function mapFunction() {
    const { Map3DElement, Marker3DInteractiveElement, PopoverElement } =
      await window.google.maps.importLibrary("maps3d");

    console.log('hello render photos called bro')
    console.log('photos are trying', mapReferenceThreed)

    props.photos.forEach((photoMarker, i) => {
      let url = photoMarker.thumbnailUrl;
      const photoMarkerTemplate = buildphotoMarkerTemplate(url, photoMarker.color, i);
      const popover = new PopoverElement();
      const header = document.createElement("span");
      header.ariaLabel = `This is photoMarker ${i + 1}: ${photoMarker.name}`;
      header.slot = "header";
      popover.append(header);
      popover.append(`${i + 1}. ${photoMarker.name}`);

      const interactivephotoMarker = new Marker3DInteractiveElement({
        title: photoMarker.name,
        position: { lat: photoMarker.latitude, lng: photoMarker.longitude },
        gmpPopoverTargetElement: popover,
      });
      interactivephotoMarker.append(photoMarkerTemplate);

      props.mapReferenceThreed.append(interactivephotoMarker);
      props.mapReferenceThreed.append(popover);

    })
  }

  return null;
}

const mapStateToProps = state => ({
  markers: state.markers,
  photos: state.photos,
  polygons: state.polygons,
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(RenderPhotos)

